import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { UserService } from '../../../core/services/user.service';
import { ToastService } from '../../services/toast.service';
import { User } from '../../models';
import { UserDropdownComponent } from '../../components/user-dropdown/user-dropdown';
import { UserProfileComponent } from '../../components/user-profile/user-profile';
import { HeaderNavComponent } from '../../components/header-nav/header-nav';
import { Dialog } from '@openng/optimus-ui/dialog';

@Component({
  selector: 'app-main-layout',
  imports: [RouterModule, UserDropdownComponent, UserProfileComponent, HeaderNavComponent, Dialog],
  changeDetection: ChangeDetectionStrategy.Default,
  templateUrl: './main-layout.html'
})
export class MainLayoutComponent implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly userService = inject(UserService);
  private readonly toastService = inject(ToastService);
  private readonly router = inject(Router);

  currentUser: User | null = null;
  showProfileModal = false;
  isSidebarCollapsed = false;

  toggleSidebar(): void {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }

  ngOnInit(): void {
    this.authService.currentUser$.subscribe(user => {
      this.currentUser = user;
    });
  }

  logout(): void {
    this.authService.logout().subscribe({
      next: () => {
        this.router.navigate(['/login']);
      },
      error: () => {
        // Even if logout fails, redirect to login
        this.router.navigate(['/login']);
      }
    });
  }

  openProfile(): void {
    this.showProfileModal = true;
  }

  closeProfile(): void {
    this.showProfileModal = false;
  }

  saveProfile(): void {
    // Profile saving is now handled internally by the UserProfileComponent
    this.closeProfile();
  }
}
